{
 "filot": [
  292,
  720
 ],
 "xaris": [
  230,
  720
 ],
 "monoi": [
  236,
  720
 ],
 "irene": [
  300,
  720
 ],
 "pitho": [
  336,
  720
 ],
 "hypnos": [
  286,
  720
 ],
 "hyga": [
  368,
  720
 ],
 "keso": [
  285,
  720
 ],
 "bia": [
  409,
  720
 ],
 "syka": [
  390,
  720
 ],
 "urax": [
  477,
  720
 ],
 "praxi": [
  283,
  720
 ],
 "pistis": [
  380,
  720
 ],
 "prono": [
  299,
  720
 ],
 "horkos": [
  289,
  720
 ],
 "meta": [
  279,
  720
 ],
 "frosy": [
  407,
  720
 ],
 "elis": [
  229,
  720
 ],
 "aidos": [
  284,
  720
 ],
 "pyda": [
  337,
  720
 ],
 "plutus": [
  291,
  720
 ],
 "kerdos": [
  294,
  720
 ],
 "uthen": [
  278,
  720
 ],
 "thera": [
  349,
  720
 ],
 "agon": [
  363,
  720
 ]
}